<div class="channel-table-row text" style="background-color: transparent">
    <div data-cy="dashboard-channel-group-tab-ch-no-column-label" class="col-ch-no">
        {{ "labels.channel.number" | translate }}
    </div>
    <div data-cy="dashboard-channel-group-tab-ch-name-column-label" class="col-ch-name">
        {{ "labels.channel.name" | translate }}
    </div>
</div>
